export default __webpack_public_path__ + "static/media/rnr-sports-table-9-cn.688d8c45.webp";